import React, { useEffect, useState, useContext } from 'react';
import { UIContext } from '../../contexts/UIContext';

import { Button } from '@mui/material';
import Image from '../Image/Image';
import {resizeImage} from '../CameraCapture/CameraCapture';

import PicturesService from "../../services/PicturesService";
import LogUtils from '../../utils/LogUtils';

import EditIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ImageIcon from '@mui/icons-material/Image';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import './ImagePicker.scss';

export default function ImagePicker({
  pictureId,
  currentUserId,
  onUpdatedPickedImg,
  onImageUpdated,
  className,
  squaredStyle,
  readOnly,
  isProfile,
  image
}) {
  const TAG = "ImagePicker";

  const {showErrorMessage} = useContext(UIContext);

  const [isMounted, setIsMounted] = useState(true);
  const [isEditEnabled, setIsEditEnabled] = useState(true);
  const [pickedImgFile, setPickedImgFile] = useState(null);
  const [pickedImgFilePath, setPickedImgFilePath] = useState(null);

  const picturesService = new PicturesService();
  const logUtils = new LogUtils();

  useEffect(() => {
    setIsMounted(true);

    return (() => {
      setIsMounted(false);
    });
  }, []);

  function onImageUpdate(e) {
    try {

      if (!isMounted) {
        return false;
      }

      e.preventDefault();

      var file = e.target.files[0];
      var path = (window.URL || window.webkitURL).createObjectURL(file);

      setPickedImgFile(file);
      setPickedImgFilePath(path);
      setIsEditEnabled(false);

    } catch (err) {
      logUtils.logErrorMsg(TAG, "Failed onImageUpdate", err);
    }
  }

  async function updatedPickedImg() {
    const ERROR_MSG = "Não foi possível utilizar a image selecionada. Por favor se certifique que você selecionou um arquivo em formato válido (png, jpg, jpeg) e que ele respeita o tamanho máximo permitido de 2MB.";

    try {
      if (!isMounted) return false;

      const optimizedImageFile = await resizeImage(pickedImgFile);

      const resOpPicture = await picturesService.upsertPicture({
        pictureId,
        pickedImgFile: optimizedImageFile,
        currentUserId
      });

      if (resOpPicture.status !== 1) {
        showErrorMessage({
          message: ERROR_MSG
        });
        logUtils.logErrorMsg(TAG, "Failed at updatedPickedImg", `Failed to picturesService.createPicture ${resOpPicture.status}`);
        return false;
      }

      if (!onUpdatedPickedImg(resOpPicture.data)) {
        showErrorMessage({
          message: ERROR_MSG
        });
        logUtils.logErrorMsg(TAG, "Failed at  updatedPickedImg", `Failed on onUpdatedPickedImg`);
        return false;
      }

      setPickedImgFile(null);
      setPickedImgFilePath(null);
      setIsEditEnabled(true);

      if (onImageUpdated) {
        onImageUpdated();
      }

      return true;

    } catch (err) {
      showErrorMessage({
        message: ERROR_MSG
      });
      logUtils.logErrorMsg(TAG, "Unabled to updatedPickedImg", err);
    }

    return false;
  }

  function cancelOperation() {

    if (!isMounted) {
      return false;
    }

    setPickedImgFile(null);
    setPickedImgFilePath(null);
    setIsEditEnabled(true);
  }

  return (
    <div className={`image-picker ${className || ""}`}>
      {
        isEditEnabled && !pickedImgFilePath ?
          <div className={`img-container ${squaredStyle ? "squared" : ""}`}>
            {isProfile && !image && <AccountCircleIcon className="profile-img"/>}
            {isProfile && image && <Image src={image} className="profile-img" />}
            {!isProfile && <ImageIcon className="regular-img"/>}
          </div>
          :
          <div className={`img-container ${squaredStyle ? "squared" : ""}`}>
            <Image src={pickedImgFilePath} className="profile-img" />
          </div>
      }
      {
        readOnly ? ("") : (
          isEditEnabled && !pickedImgFilePath ?
            <div className="confirm-picked-img-container">
              <Button className="pick-img-btn">
                <EditIcon className="pick-img-btn-ico" />
                <input type="file" id="avatar" name="avatar" accept="image/png, image/jpeg" onChange={onImageUpdate} />
              </Button>
            </div>
            :
            <div className="confirm-picked-img-container">
              <Button className="confirm-picked-img-btn" onClick={updatedPickedImg}>
                <CheckIcon className="img confirm-picked-img-btn-img" />
              </Button>
              <Button className="cancel-picked-img-btn" onClick={cancelOperation}>
                <CloseIcon className="img confirm-picked-img-btn-img" />
              </Button>
            </div>
        )
      }
    </div>
  );
}